import { HtmlViewer } from 'shared';
import { HotjarSuppression } from 'shared_DEPRECATED/components/Hotjar';
import Spacer from 'shared_DEPRECATED/components/Spacer';

import { Typography } from 'shared/components/Typography';

export const SessionsRecapContent = ({ content }: { content: string }) => (
  <>
    <Spacer size="md zr" />
    <Typography as="div" type="meta" color="black" whiteSpace="pre-wrap">
      <HotjarSuppression>
        <HtmlViewer rawHtml={content} key={content} />
      </HotjarSuppression>
    </Typography>
  </>
);
